import { create } from 'zustand';

export type AuthUser = {
  id: string;
  email: string;
  fullName: string | null;
  roles: string[];
  perms: string[];
  totpEnabled: boolean;
  /** Set when an admin issued a temp password; the app pins the change-password screen. */
  mustChangePassword: boolean;
  /** Present only for an admin's "Login as" session; drives the return banner. */
  impersonator?: { userId: string; email: string } | null;
};

type AuthState = {
  token: string | null;
  user: AuthUser | null;
  setSession: (token: string, user: AuthUser) => void;
  setMustChangePassword: (value: boolean) => void;
  clear: () => void;
};

/** In-memory only, by rule: the access token never touches browser storage. */
export const useAuthStore = create<AuthState>((set) => ({
  token: null,
  user: null,
  setSession: (token, user) => set({ token, user }),
  setMustChangePassword: (value) =>
    set((s) => (s.user ? { user: { ...s.user, mustChangePassword: value } } : s)),
  clear: () => set({ token: null, user: null }),
}));
